export const setLimitedInterval = (
  action: () => boolean | undefined,
  timeout = 1000,
  maxExecutions = 5
) => {
  if (action()) {
    return;
  }

  let counter = 0;
  const intervalId = setInterval(() => {
    counter++;
    if (action()) {
      clearInterval(intervalId);
    }
    if (counter >= maxExecutions) {
      clearInterval(intervalId);
    }
  }, timeout);
};
